// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-right"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9.5 17.5L15 12L9.5 6.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronRightIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-right',
    ref,
    icon: element,
  },
));

ChevronRightIcon.displayName = 'ChevronRightIcon';

export default ChevronRightIcon;
